import _get from 'lodash/get';
const getIcoOffers = async _ref => {
  let {
    icoFetcher,
    pixAllId
  } = _ref;
  const toDate = new Date();
  const fromDate = new Date(toDate);
  fromDate.setDate(fromDate.getDate() - 30);
  const icoResponse = await icoFetcher.fetch({
    pixAllId,
    fromDate: fromDate.toISOString().slice(0, -1),
    toDate: toDate.toISOString().slice(0, -1),
    pagesize: 2,
    pageNumber: 1,
    sort: '-createdDate'
  });
  const items = _get(icoResponse, 'items', []);
  const offers = [];
  if (items.length > 0) {
    items.forEach(item => {
      const {
        id: offerId,
        createdDate,
        expirationDate,
        status,
        vehicle = {},
        owner = {},
        vehiclePrice = {}
      } = item;
      const {
        kbbVehicleId: vehicleId,
        mileage,
        chosenCondition: condition
      } = vehicle;
      offers.push({
        offerId,
        createdDate,
        expirationDate,
        status,
        vehicleId,
        mileage,
        condition,
        zip: owner.zipCode,
        instantCashOffer: vehiclePrice.final
      });
    });
  }
  return offers;
};
export { getIcoOffers as default };
